import OrganizationDocument from "./organizationDocument";
import {RelationType} from "../../../common/models/relationType";
import Share from "../../../common/models/share";

/**
 * @deprecated Only use the TrackedModel version of Form
 */
export default class Form extends OrganizationDocument {
  modelKey = 'form';
  collectionKey = 'forms';

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'shares': {type: Share, relationType: RelationType.collection},
    };
  }

  static get displayName(): string {
    return 'Form';
  }

  get isForm(): boolean {
    return true;
  }

  get classKey(): string {
    return 'form';
  }

  get rootName(): string {
    return 'form';
  }
}